import React from 'react';

interface SliderNavigationProps {
  onPrevClick: () => void;
  onNextClick: () => void;
}

const LiteSliderNavigation: React.FC<SliderNavigationProps> = ({ onPrevClick, onNextClick }) => {
  return (
    <div className="liteSlider__control">
      <button
        type="button"
        className="liteSlider__control-link liteSlider__control-link--prev"
        onClick={onPrevClick}
        role="button"
        aria-label="Prev slide"
      >
        Previous
      </button>
      <button
        type="button"
        className="liteSlider__control-link liteSlider__control-link--next"
        onClick={onNextClick}
        role="button"
        aria-label="Next slide"
      >
        Next
      </button>
    </div>
  );
};

export default LiteSliderNavigation;
